export default __webpack_public_path__ + "static/media/device-mobile-2.bc61e4de.png";